import { type SVGProps } from "react";

import { cn } from "@/shared/helpers/cn.helper";

interface MicrosoftIconProps extends SVGProps<SVGSVGElement> {
  className?: string;
}

export const MicrosoftIcon = ({ className, ...props }: MicrosoftIconProps) => (
  <svg
    className={cn(className)}
    fill="none"
    height="24"
    viewBox="0 0 24 24"
    width="24"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M11.4062 11.4041H0V0H11.4062V11.4041Z"
      fill="#F1511B"
    />
    <path
      d="M24 11.4041H12.594V0H24V11.4041Z"
      fill="#80CC28"
    />
    <path
      d="M11.4059 24H0V12.596H11.4059V24Z"
      fill="#00ADEF"
    />
    <path
      d="M24 24H12.594V12.596H24V24Z"
      fill="#FBBC09"
    />
  </svg>
);

export default MicrosoftIcon;
